import { gql } from '@apollo/client'

export default gql(`
    mutation($id: ID! $project: String) {
        deleteAuthor(
            input: {
                id: $id
            }
            project: $project
        ) {
            id
            name
        }
    }`
)
